import BlockType from 'src/enums/blockType';
import bumpoutIcon from 'src/svgIcons/bumpoutIcon';
import deckboxIcon from 'src/svgIcons/deckboxIcon';
import landingIcon from 'src/svgIcons/landingIcon';
import stairIcon from 'src/svgIcons/stairIcon';
import { Block } from 'src/types/shared/blocksV3';

function getAddableBlocks(block: Block | null) {
	const blocks = [
		{
			name: 'DeckBox',
			color: '#8BC34A',
			icon: deckboxIcon,
			blockType: BlockType.DECKBOX,
			show: block?.type == BlockType.DECKBOX,
		},
		{
			name: 'Landing',
			color: '#FFB200',
			icon: landingIcon,
			blockType: BlockType.LANDING,
			show: block?.type == BlockType.DECKBOX || block?.type == BlockType.STAIR,
		},
		{
			name: 'Stair',
			color: '#FF9800',
			icon: stairIcon,
			blockType: BlockType.STAIR,
			show:
				block?.type == BlockType.DECKBOX || block?.type == BlockType.LANDING,
		},
		{
			name: 'Bumpout',
			color: '#C3D6AD',
			icon: bumpoutIcon,
			blockType: BlockType.BUMPOUT,
			show: block?.type == BlockType.DECKBOX,
		},
	].filter((block) => block.show);

	return blocks;
}

export default getAddableBlocks;
